export default __webpack_public_path__ + "static/media/it.b53c34f7.svg";